const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  display: flex;
  align-items: flex-start;
  flex-grow: 1;
  font: var(--goto-body-medium);
  border-color: var(--goto-surface-color-brand-secondary);
  border-width: 4px;
  color: var(--goto-type-color-default);
}
:host .badge {
  font: var(--goto-caption-medium);
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--goto-surface-color-brand-secondary);
  color: var(--goto-type-color-default);
  border-radius: 50%;
  min-width: var(--goto-layout-02);
  min-height: var(--goto-layout-02);
}
:host .step-text {
  overflow: hidden;
  width: 100%;
}
:host .step-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  margin-top: 2px;
}
:host .step-description {
  font: var(--goto-body-medium);
  display: -webkit-box;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--goto-type-color-secondary);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

:host([selected]),
:host([variant=success]) {
  --goto-icon-color: var(--goto-icon-color-inverted);
  border-color: var(--goto-surface-color-brand-default);
}
:host([selected]) .badge,
:host([variant=success]) .badge {
  color: var(--goto-icon-color-inverted);
  background-color: var(--goto-surface-color-brand-default);
}

:host([variant=success]) {
  --goto-icon-size: var(--goto-layout-02);
}

:host([variant=danger]) {
  --goto-icon-color: var(--goto-icon-color-danger);
  --goto-icon-size: var(--goto-layout-02);
  --goto-link: var(--goto-type-color-danger);
  border-color: var(--goto-surface-color-danger-default);
  color: var(--goto-type-color-danger);
}
:host([variant=danger]) .badge {
  color: inherit;
  background: none;
}

:host([disabled]) {
  --goto-icon-color: var(--goto-type-color-disabled);
  color: var(--goto-type-color-disabled);
  border-color: var(--goto-surface-color-secondary);
}
:host([disabled]) .badge,
:host([disabled]) .step-description {
  color: inherit;
}
:host([disabled]) .badge {
  background-color: var(--goto-surface-color-secondary);
}

:host([disabled][variant=danger]) .badge {
  color: inherit;
  background: none;
}

chameleon-tooltip-v2 {
  width: calc(100% - var(--goto-layout-02) - var(--goto-spacing-02));
}

chameleon-tooltip-v2::part(popover) {
  max-width: fit-content !important;
}

chameleon-tooltip-v2 span[id^=cham-popover-trigger-] {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

chameleon-link {
  width: 100%;
}

chameleon-link::part(control) {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 0;
  margin: 0;
}`; export default styles;